import classNames from 'classnames'
import * as React from 'react'

import DynamicIcon from '@/components/DynamicIcon'
import Image from '@/components/Image'
import Link from '@/components/Link'

export const Author = ({author, className, isWhite}) => {
  return (
    author && (
      <div className={classNames('flex flex-col gap-8', className)}>
        <div
          className={classNames(
            'flex items-center justify-between rounded-[40px] border p-6',
            isWhite ? 'border-purple-200 bg-white' : 'border-transparent bg-yellow-200'
          )}
        >
          <div className='flex items-center gap-6'>
            <Image
              {...author.content.image}
              ratio='1:1'
              sizes={{sm: '40', unit: 'px'}}
              className='h-20 w-20 rounded-full'
              alt=''
            />
            <div className='flex flex-col gap-4'>
              {author.content.authorPage ? (
                <Link link={author.content.authorPage} className='body-xl-bold'>
                  {author.content.name}
                </Link>
              ) : (
                <p className='body-xl-bold'>{author.content.name}</p>
              )}
              <span className='body-m-medium'>
                {author.content.company} - {author.content.job}
              </span>
            </div>
          </div>
          {author.content.linkedin.url && (
            <Link link={author.content.linkedin} className='rounded-2xl bg-yellow-300 p-4'>
              <DynamicIcon aria-hidden icon={'IconLinkedin'} />
            </Link>
          )}
        </div>
      </div>
    )
  )
}
